/* eslint-disable camelcase */
import i18n from 'i18next';

import getEnrollmentsMaximum from '../helpers/getEnrollmentsMaximum';

const getMaximumVersionWarningText = ({ enrolledUsers, enrollmentsSelectedUsers }) => {
  const { difference, maximum, selectedCount, shouldEnforceMaximum } = getEnrollmentsMaximum({
    enrolledUsers,
    enrollmentsSelectedUsers,
  });

  if (shouldEnforceMaximum)
    return i18n.t('max-enrollments-reached-enforced', { difference, maximum });

  const enrollmentTextKey =
    selectedCount === 1
      ? 'max-enrollments-reached-warning-singlular'
      : 'max-enrollments-reached-warning-plural';
  return i18n.t(enrollmentTextKey, {
    count: selectedCount.toLocaleString(document.documentElement.lang),
    difference: difference.toLocaleString(document.documentElement.lang),
  });
};

const getMaximumVersionBannerType = ({ enrolledUsers, enrollmentsSelectedUsers }) => {
  const { difference, maximum, shouldEnforceMaximum } = getEnrollmentsMaximum({
    enrolledUsers,
    enrollmentsSelectedUsers,
  });

  const shouldUseWarning = shouldEnforceMaximum && maximum && difference >= 0;

  return shouldUseWarning ? 'Warning' : 'Info';
};

const getStatusOptions = ({ statuses }) =>
  statuses.map((status, index) => ({
    id: index + 1,
    value: status,
    label: i18n.t(status),
  }));

export default ({ relationship_type, enrolledUsers, enrollmentsSelectedUsers, statuses }) => ({
  course_attendance_max: {
    type: getMaximumVersionBannerType({ enrolledUsers, enrollmentsSelectedUsers }),
    icon: 'cautionOutlined',
    iconSize: 18,
    isDecoration: true,
    text: getMaximumVersionWarningText({ enrolledUsers, enrollmentsSelectedUsers }),
    validators: [
      { type: 'isCourseEnrollmentsLimitEnforced', enrolledUsers, enrollmentsSelectedUsers },
    ],
    conditions: [
      {
        type: 'isCourseEnrollmentsLimitReached',
        shouldHideField: true,
        enrolledUsers,
        enrollmentsSelectedUsers,
      },
    ],
  },
  due_on: {
    type: 'Date',
    label: i18n.t('due'),
    placeholder: i18n.t('select-date'),
    validators: [{ type: 'isRequired' }],
  },
  status: {
    type: 'Select',
    label: i18n.t('status'),
    validators: [{ type: 'isRequired' }],
    selectProps: {
      isFullWidth: true,
    },
    options: getStatusOptions({ statuses }),
  },
  relationship_type: {
    type: 'Radio',
    label: 'Type',
    options: [
      { label: i18n.t('recommended'), value: 'recommended' },
      { label: i18n.t('required'), value: 'required' },
    ],
  },
  recommended_by: {
    type: 'Text',
    label: relationship_type === 'required' ? i18n.t('required-by') : i18n.t('recommended-by'),
  },
  relationship_reason: {
    type: 'TextArea',
    label: i18n.t('reason'),
  },
});
